import React from 'react';
import { Button, Table, Header, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

export default class ActivateCourse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],

        };
        this.getFaculties = this.getFaculties.bind(this);
        this.activate = this.activate.bind(this);
    }

    componentDidMount() {
        this.getFaculties();
    }

    getFaculties() {
        axios.get(`course/organizational-units/${this.props.location.state.id}`)
            .then(res => {
                const dataa = res.data;
                this.setState({ data: dataa });
            })
            .catch(err => {
                console.log('Failed to fetch courses');
            });
    }

    activate(id, optlock, courseBasicId, organizationalUnitId, mainFaculty) {
        let activeCourse = {
            id, optlock, courseBasicId, organizationalUnitId, mainFaculty
        };

        axios.put('/course/basic/unarchive', { ...activeCourse })
            .then(res => {
                toast('Predmet je uspješno aktiviraj!');
            })
            .catch(err => {
                toast('Došlo je do greške! Predmet nije aktiviran.');
            });
        window.history.go(-1);
    }


    render() {
        return (
            <div>
                <Header as="h1">Detalji / aktiviranje</Header>
                <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3">
                            {this.props.location.state.name}
                        </Header>
                    </Segment>
                    <Segment clearing>
                        <Table celled selectable compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>
                                        Fakulteti
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body> {this.state.data.map((el, index) =>
                                (<Table.Row key={index}>
                                    <Table.Cell verticalAlign="middle">
                                        {el.organizationalUnit.name}
                                    </Table.Cell>
                                    <Table.Cell textAlign="center">
                                        <Button
                                            color="green"
                                            basic="true"
                                            onClick={
                                                () => {
                                                    this.activate(
                                                        el.id,
                                                        el.optLock,
                                                        el.courseBasic.id,
                                                        el.organizationalUnit.id,
                                                        el.mainFaculty
                                                    );
                                                }
                                            }
                                        >
                                            Aktiviraj predmet
                                        </Button>
                                    </Table.Cell>


                                </Table.Row>))}
                            </Table.Body>
                        </Table>

                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateCourse/ActivateCourse.js